import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from 'next/router';
import { bindActionCreators } from 'redux';

import {
    cleanText, cdnApi, serverApiEurope, ratingValue, secToTime, bytesToMB, getPodcastImg,
    getPodcastImgSize, convertToSlug, sortUserPlaylists, getDescription, isLocalStoragePresent,
    getCurrentEpisodeData, cleanGenres, singular, getUUID, podcastSlugUrl, podcastHrefUrl, setCurrentPodcastData,
    retrieveLocally,
    secToDateFromPubDate,
    cleanFirebaseId,
    secToDateDay,
    secToDate,
    isAdmin
} from '../../lib/utils';
import { spacing, colors, fixedSpacing, minImageWidth, fontSize } from '../../lib/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { logEpisodeData, getEpisodeFromFirestore, setEpisodeAsPlayed, getPodcastDataDB, fetchAutoChapters, editBookChapter } from '../../actions';

// import { getItunesDataByCollectionId } from '../../lib/searchItunes';
import ExpandCollapse from '../ExpandCollapse';
import Review from '../Review/Review';
import PlayMain from '../Common/PlayMain';
import LoadingSpinner from '../Common/Loading';
import AutoChapters from '../Common/AutoChapters';
import AppShare from '../Common/AppShare';
import InvalidPodcast from '../Podcast/InvalidPodcast';
import EmptyState from '../Common/EmptyState';

import { Button, Col, Input, Menu, message, Rate, Row, Tabs } from 'antd';
const { TextArea } = Input;
import { CheckCircleOutlined, HeartFilled, PlusCircleOutlined } from '@ant-design/icons';

import NewPlaylist from '../Playlist/NewPlaylist';
import AddPlaylistTile from '../Playlist/AddPlaylistTile';
import AppOptions from '../Common/AppOptions';
import EpisodeReviewList from '../Review/EpisodeReviewList';
import { logPodcastEpisodeClick } from '../../lib/analyticsEvents';
import AddToQueue from '../Queue/AddToQueue';
import AppShareModal from './AppShareModal';
import PlayTrailer from './PlayTrailer';
import DownloadEpisode from './DownloadEpisode';
import EpisodeDescription from '../EpisodeDescription';
import EpisodePageUser from './EpisodePageUser';

const SubMenu = Menu.SubMenu;

class EpisodePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itunesLoaded: false, loadingEpisode: true, visible: false
        };
        // this.props.loadingUserDetailsState(true);
    }

    componentDidMount() {
        // this.getEpisodeData(this.props.itunesId);
        const { podcastEpisodeServer, uuid } = this.props;
        if (uuid) {
            this.getItunesData();
            this.setEpisodeData(podcastEpisodeServer);

            this.setState({ loadingEpisode: false });
        }
    }

    componentDidUpdate(prevProps) {
        const { podcastEpisodeServer, uuid } = this.props;
        if (uuid && uuid !== prevProps.uuid) {
            this.setState({ itunesLoaded: false, loadingEpisode: true });

            this.getItunesData();
            this.setEpisodeData(podcastEpisodeServer);

            this.setState({ loadingEpisode: false });
        }
    }

    async setEpisodeData(podcastEpisodeServer) {
        const { isServer, uuid, userDetails } = this.props;
        let logData = false;
        let episodeLocal;
        // this.setEpisodeAutoChapters();
        if (isServer) {
            if (!podcastEpisodeServer.guid) {
                episodeLocal = this.setLocalEpisodeData();
                logData = true;
            }
        } else {
            episodeLocal = this.setLocalEpisodeData();
            console.dir(episodeLocal);
            try {
                // ///*********** use serverApi here as you need to check and log data. */
                // const response = await fetch(`${serverApiEurope}episodes?id=${(guid)}`);
                // let episodeData = await response.json();
                let episodeData = await getEpisodeFromFirestore(uuid);
                const isUserAdmin = isAdmin(userDetails);
                if (isUserAdmin) {
                    this.setState({ episodeClient: episodeData });
                }
                console.dir(episodeData);
                if (!episodeData.guid) {
                    logData = true;
                } else {
                    // if (this.props.type !== 'drawer') { ************ don't uncomment this, causes an issue in episode search
                    this.setState({ episodeClient: episodeData });
                    // }
                    if (episodeData && episodeData.collectionId) {
                        // if (episodeData.collectionId > 0) {
                        //     getItunesDataByCollectionId(episodeData.collectionId).then((data) => {
                        //         console.dir(data);
                        //         this.setState({ itunesLoaded: true, itunesData: data });
                        //     })
                        // } else {
                        // getPodcastDataDB(episodeData.collectionId).then((data) => {
                        //     console.dir(data);
                        //     this.setState({ itunesLoaded: true, itunesData: data });
                        // })
                        // }
                    }
                }
            } catch (error) {
                console.error(error);
                // throw error;
            }
        }
    }

    setEpisodeAutoChapters() {
        const { uuid } = this.props;
        console.dir(uuid);
        this.props.fetchAutoChapters(uuid);
    }

    setLocalEpisodeData() {
        const { userDetails } = this.props;
        const isUserAdmin = isAdmin(userDetails);
        if (isUserAdmin) {
            return {};
        }
        let episodeLocal = this.getCurrentEpisode();
        this.setState({ episodeClient: episodeLocal }, () => {
            console.dir(this.state.episodeClient);
        });
        return episodeLocal;
    }

    getCurrentEpisode = () => {
        const { podcastEpisodeServer } = this.props;
        if (podcastEpisodeServer && podcastEpisodeServer.guid) {
            return podcastEpisodeServer;
        }
        let episodeLocalParse;
        if (isLocalStoragePresent() && localStorage.getItem('lastLocalEpisode') !== null) {
            episodeLocalParse = JSON.parse(localStorage.getItem('lastLocalEpisode'));
        } else {
            episodeLocalParse = getCurrentEpisodeData();
        }
        console.dir(episodeLocalParse);
        return episodeLocalParse;
    }

    getItunesData() {
        let episodeLocal = this.getCurrentEpisode();
        const itunesId = episodeLocal.collectionId;
        if (itunesId && itunesId > 0) {
            // getItunesDataByCollectionId(itunesId).then((data) => {
            //     this.setState({ itunesLoaded: true, itunesData: data })
            // })
        }
        logPodcastEpisodeClick(episodeLocal);
    }

    backToSeries = () => {
        const { onCloseChild, podcastEpisodes } = this.props;
        if (onCloseChild) {
            onCloseChild();
        }
        // let episodeLocal = this.getCurrentEpisode();
        // const { itunesData } = this.state;
        // console.dir(itunesData);
        if (podcastEpisodes != null && podcastEpisodes.length > 0) {
            const itunesId = podcastEpisodes[0].collectionId;
            // let cleanedGenres = cleanGenres(itunesData.genres);
            // let genres = cleanedGenres.join(',');
            // setCurrentPodcastData(itunesData);
            Router.push(podcastHrefUrl(itunesId), podcastSlugUrl(podcastEpisodes[0].collectionName, itunesId));
        }
    }

    isInAnyPlaylist() {
        let inPlaylist = false;
        let episodeLocal = this.getCurrentEpisode();
        const guid = episodeLocal.guid;
        const { userPlaylists } = this.props;
        // const { episodeClient } = this.state;
        // const podcastEpisode = (podcastEpisodeServer.guid) ? podcastEpisodeServer : episodeClient;
        for (let playlist of Object.values(userPlaylists)) {
            if (!inPlaylist && playlist['guidEpisodeArray']) {
                for (let guidPlaylist of playlist['guidEpisodeArray']) {
                    // let episodeGUID = podcastEpisode['guid'] || '';
                    if (guidPlaylist == guid) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    markPlayedClick = (isMarkedAsPlayed) => {
        const { podcastEpisodeServer, userDetails } = this.props;
        const { episodeClient } = this.state;
        const podcastEpisode = (podcastEpisodeServer.guid) ? podcastEpisodeServer : episodeClient;
        if (!userDetails || !userDetails.uid) {
            message.warning('Please sign in to mark as played.');
            return;
        }
        this.props.setEpisodeAsPlayed(podcastEpisode, !isMarkedAsPlayed);
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };
    changeTitle = e => {
        const { episodeClient } = this.state;
        this.setState({ episodeClient: { ...episodeClient, title: e.target.value } });
    }
    saveTitle = () => {
        if (window.confirm("Are you sure?")) {
            const { episodeClient } = this.state;
            // const { insight } = this.state;
            // const { guid } = this.props;
            editBookChapter(episodeClient.guid, '', '', episodeClient.title).then(() => {
                message.success('Updated Title.');
            }).catch(err => {
                alert('There was an error saving. Contact suboo');
            })
            return;
        }
    }
    render() {
        const { userDetails, podcastEpisodeServer, podcastEpisodes, userPlaylists, type, personalMarkPlayedValues,
            appEpisodeNumber, personalValues, myFiles, uuid, rawTokenCount, isServer, itunesData } = this.props;
        const { episodeClient, itunesLoaded, loadingEpisode, visible } = this.state;
        const isUserAdmin = isAdmin(userDetails);
        console.dir(rawTokenCount);
        console.dir(appEpisodeNumber);
        console.dir(episodeClient);

        let podcastEpisode;
        if (isUserAdmin) {
            if (!episodeClient || !episodeClient.guid) {
                return <></>
            }
            podcastEpisode = episodeClient; //(podcastEpisodeServer.guid) ? podcastEpisodeServer : episodeClient;
        } else {
            podcastEpisode = (podcastEpisodeServer.guid) ? podcastEpisodeServer : episodeClient;
        }


        // console.dir(episodeClient);
        console.dir(podcastEpisodeServer);
        // console.dir(episodeClient);
        // let episodeLocal = this.getCurrentEpisode();
        const guid = podcastEpisode?.guid;

        if (!podcastEpisode || !guid) {
            // return (<InvalidPodcast message="Sorry we couldn't find this episode. Please check the url and try again." />)
            return <EmptyState message="Sorry we couldn't find this episode. Please try again or search in a similar podcast." imageName='podcast-not-found' />
        }

        // const { loadingEpisodeReviews } = this.props.loadingState;
        // const { userDetails } = this.props;
        const pubDateParsed = podcastEpisode.pubDate ? new Date(podcastEpisode.pubDate) : '';


        let userPlaylistsSorted = sortUserPlaylists(userPlaylists, userDetails); // {};
        // Object
        //     .keys(userPlaylists).sort(function (a, b) {
        //         return userPlaylists[a].name.localeCompare(userPlaylists[b].name);
        //     })
        //     .forEach(function (key) {
        //         userPlaylistsSorted[key] = userPlaylists[key];
        //     });

        const guidCleaned = cleanFirebaseId(podcastEpisode.guid);
        const personalMarkPlayedValuesSpecific = personalMarkPlayedValues[`${guidCleaned}`] || false;
        const personalValuesSpecific = personalValues[`${guidCleaned}`] || {};
        const isMarkedAsPlayed = personalMarkPlayedValuesSpecific || personalValuesSpecific['markAsPlayed'] || false;

        const menu = (
            <Menu>
                <Menu.Item key="download"><DownloadEpisode podcastEpisode={podcastEpisode} /></Menu.Item>
                <Menu.Item key="markAsPlayed">
                    <a onClick={this.markPlayedClick.bind(this, isMarkedAsPlayed)}>
                        <p className='mb-0'>
                            <FontAwesomeIcon style={{ marginRight: '4px' }} icon={isMarkedAsPlayed ? 'times-circle' : 'check-circle'} />
                            {isMarkedAsPlayed ? 'Mark as Unplayed' : 'Mark as Played'}
                        </p>
                    </a>
                </Menu.Item>
                <SubMenu title={<div style={{ display: 'inline' }}>
                    <p style={{ display: 'inline' }}>
                        {this.isInAnyPlaylist() ? <CheckCircleOutlined style={{ color: 'green' }} /> : <PlusCircleOutlined />}&nbsp;Add to Playlist</p>
                </div>}>
                    <Menu.Item key="newPlaylist" style={{ padding: '0' }}><NewPlaylist podcastDetails={podcastEpisode} /></Menu.Item>
                    <Menu.Divider />
                    {userDetails && Object.values(userPlaylists).length > 0 && Object.keys(userPlaylistsSorted).map((userPlaylistId) => (
                        <Menu.Item key={userPlaylistId}>
                            <AddPlaylistTile key={userPlaylistId} userPlaylistId={userPlaylistId} userPlaylist={userPlaylistsSorted[userPlaylistId]}
                                podcastEpisode={podcastEpisode} />
                        </Menu.Item>

                    ))
                    }
                </SubMenu>
                <Menu.Item key="addToQueue"><AddToQueue podcastEpisode={podcastEpisode} /></Menu.Item>
            </Menu>
        );

        const episodeShareUrl = `https://tedapp.ai/episode/${getUUID(podcastEpisode?.guid || '')}`;

        const isDrawer = type === 'drawer';
        const isMyFile = podcastEpisode.isMyFile;
        if (!isUserAdmin) {
            return <EpisodePageUser podcastEpisodeServer={podcastEpisode} itunesData={itunesData}
                backToSeries={this.backToSeries}
                podcastEpisodes={podcastEpisodes} isServer={isServer} uuid={uuid} />
        }
        return (
            <div className='list'>
                {/* {!isMyFile &&
                    <Button type='' style={{ marginBottom: `${spacing()}` }} disabled={!itunesLoaded || !itunesData || !itunesData.feedUrl} onClick={this.backToSeries}>Go to Series</Button>
                } */}
                {podcastEpisode.guid &&
                    <div>
                        {/* <div>
                            <Row style={{ margin: '0.75em 0' }}>
                                <Col xs={17} xl={18}>
                                    <PlayMain style={{ width: '11vw' }} podcastEpisode={podcastEpisode} iconType='button' />
                                </Col>
                                <Col style={{ textAlign: 'right', marginTop: `${spacing('xs')}` }} xs={7} xl={6}>
                                    {
                                        <Dropdown overlay={menu} trigger={['click']}>
                                            <a className="ant-dropdown-link" href="#">
                                                <AppOptions />
                                            </a>
                                        </Dropdown>
                                    }
                                </Col>
                            </Row>
                            <div style={{ marginBottom: '12px' }}>
                                <PlayTrailer episode={podcastEpisode} myFiles={myFiles} />
                            </div>
                            {!isMyFile && <div>
                                <Button style={{ width: '100%', color: `${colors.primary}` }} onClick={this.showModal.bind(this)}>
                                    <FontAwesomeIcon className='' icon={['fas', 'share-square']} style={{ fontSize: '16px' }} />
                                    <span style={{ transform: 'translate(4px, 0em)' }}>Share</span></Button>
                                <AppShareModal visible={visible} shareUrl={episodeShareUrl} title={`Episode: ${cleanText(podcastEpisode.title)}`}
                                    type='episodes' data={podcastEpisode} handleCancelModal={this.handleCancel} />
                            </div>}
                        </div> */}
                        <Row style={{ paddingBottom: `${spacing()}` }}>
                            {/* <Col xs={8} md={4} xl={isDrawer ? 6 : 4} style={{ paddingBottom: `${spacing()}` }}>

                            </Col> */}
                            <Col xs={{ span: 14, offset: 2 }} xl={{ span: isDrawer ? 23 : 19, offset: 1 }}>
                                <div style={{ display: 'flex' }}>
                                    {/* <a >
                                        <Icon style={{ float: 'left', fontSize: `calc(1.25*${fixedSpacing('md')})` }} type="play-circle" theme="twoTone" />&nbsp;&nbsp;
                                    </a> */}
                                    <h1 className='episode-title'>{appEpisodeNumber ?? 1}.
                                        {/* {podcastEpisode && cleanText(podcastEpisode.title)} */}
                                    </h1>

                                    <TextArea placeholder="Title" value={podcastEpisode.title}
                                        onChange={this.changeTitle}
                                        rows={1}
                                    />
                                    <Button type='primary' onClick={this.saveTitle}>Save Title</Button>
                                </div>
                                <h4 style={{ marginTop: `${spacing('xxs')}` }}>
                                    {/* <a target="_blank" rel="noopener noreferrer" href={podcastInfo.link}> */}
                                    {/* <a onClick={this.backToSeries}>{cleanText(podcastEpisode.collectionName || podcastEpisode.author)} &nbsp;</a> */}
                                    {/* <span style={{ fontSize: `${spacing('sm')}`, position: 'absolute' }} ><FontAwesomeIcon icon='external-link-alt' size='sm' /></span> */}
                                    {/* </a> */}
                                </h4>
                                {!isMyFile &&
                                    <Row style={{ marginBottom: `${spacing('sm')}` }}>
                                        <Col xs={24} xl={16}>
                                            {/* <div className='app-rating'>
                                                <Rate style={{ color: `${colors.third}`, fontSize: `${fixedSpacing('')}` }} character={<HeartFilled />}
                                                    disabled allowHalf onHoverChange={() => { }} value={ratingValue(podcastEpisode.rating, 1, 'num')} /> &nbsp;
                                                <p style={{ display: 'inline' }}>{ratingValue(podcastEpisode.rating)} ({podcastEpisode.ratedBy || 0} {singular('rating', podcastEpisode.ratedBy)})
                                                </p>
                                            </div> */}
                                        </Col>
                                        {/* <Col xs={0} xl={8}>
                                        {!loadingUserDetails && userDetails && <div style={{ marginTop: '4px' }}>
                                            <p style={{ float: 'left', marginTop: '1px' }}>Your rating:</p>
                                            <div style={{ float: 'left', width: '50%' }}>
                                                <RatingModal podcastEpisode={podcastEpisode} />
                                            </div>
                                        </div>}
                                    </Col> */}
                                    </Row>}
                                {isUserAdmin &&
                                    <Row style={{ marginBottom: `${spacing('sm')}` }}>
                                        <Col xs={12} xl={8}>
                                            {getUUID(podcastEpisode.guid)}
                                            {/* <FontAwesomeIcon icon={['far', 'calendar-alt']} /> &nbsp;<p style={{ display: 'inline' }}>{secToDateFromPubDate(pubDateParsed, true)}</p> */}
                                            {/* {pubDateParsed ? new Intl.DateTimeFormat('en-GB', {
                                            year: 'numeric',
                                            month: 'short',
                                            day: '2-digit'
                                            // }).format(new Date(podcastEpisode.pubDate))}</p>
                                        }).format(pubDateParsed) : '-'} */}
                                            {/* <Col span={6}>
                                        <Icon type="download" /> {bytesToMB(podcastEpisode.enclosure && podcastEpisode.enclosure.length)}
                                    </Col> */}
                                        </Col>
                                        <Col xs={12} xl={6} style={{ textAlign: 'center' }}>
                                            <p>Rough token count - {(rawTokenCount ?? {})[appEpisodeNumber]}</p>
                                        </Col>
                                        <Col xs={12} xl={4} style={{ textAlign: 'center' }}>
                                            <FontAwesomeIcon icon={['far', 'clock']} /> &nbsp;<p style={{ display: 'inline' }}>{secToDate(podcastEpisode.lastUpdated && podcastEpisode.lastUpdated / 1000 || 0)}</p>
                                        </Col>
                                    </Row>}
                                <Col xs={0} xl={24}>
                                    <EpisodeDescription podcastEpisode={podcastEpisode} guid={podcastEpisode.guid} description={podcastEpisode.description} />
                                    {/* <ExpandCollapse key={podcastEpisode.description} textInfo={podcastEpisode.description
                                        && podcastEpisode.description.replace(/<br>/g, '') || 'No Description'} parent='podcast' /> */}
                                </Col>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} xl={0}>
                                <ExpandCollapse key={podcastEpisode.description} textInfo={podcastEpisode.description
                                    && podcastEpisode.description.replace(/<br>/g, '') || 'No Description'} parent='podcast' />
                            </Col>
                        </Row>
                        {/* {!isMyFile &&
                            <Tabs defaultActiveKey="1">
                                <Tabs.TabPane tab="Auto Chapters" key="1">
                                    <AutoChapters uuid={uuid} podcastEpisode={podcastEpisode} />
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Reviews" key="2">
                                    <EpisodeReviewList podcastEpisode={podcastEpisode} />
                                </Tabs.TabPane>
                            </Tabs>} */}
                    </div>}
                {loadingEpisode && <LoadingSpinner message='Loading episode...' />}
                {!loadingEpisode && (!podcastEpisode || !podcastEpisode.guid) &&
                    // <InvalidPodcast message="Sorry we couldn't find this episode. Please try again or search in a similar podcast." />
                    <EmptyState message="Sorry we couldn't find this episode. Please try again or search in a similar podcast." imageName='podcast-not-found' />
                }
                <style jsx>
                    {`
                // h2 {
                //   margin-bottom: ${spacing('xxs')};
                // }
                .episode-title{
                    display: inline;
                    font-size: ${fontSize('md')};
                }
                .main-img-loc {
                    max-width: 100%;
                    // width: 11vw;
                    // min-height: 160px;
                    // min-width: ${minImageWidth};
                    margin-right: ${spacing('lg')};
                    margin-bottom: ${spacing('md')};
                    border-radius: 1em; // ${spacing('lg')};
                    box-shadow: 0 20px 40px 0 rgba(0,11,40,.14); // 0 8px 8px rgba(0,0,0,0.30), 0 4px 4px rgba(0,0,0,0.22);
            //   box-shadow: 0 8px 8px rgba(0,0,0,0.30), 0 4px 4px rgba(0,0,0,0.22);
                }
                :global(.app-rating .ant-rate-star > div:hover, .app-rating .ant-rate-star > div:focus) {
                    transform: scale(1);
                }
            `}
                </style>
            </div>
        );
    }
}

EpisodePage.propTypes = {
    podcastEpisodeServer: PropTypes.object,
    itunesData: PropTypes.object,
    podcastEpisodes: PropTypes.array,
    // guid: PropTypes.string,
    uuid: PropTypes.string,
    type: PropTypes.string,
    // itunesId: PropTypes.string,
    userDetails: PropTypes.object,
    loadingState: PropTypes.object,
    userPlaylists: PropTypes.object,
    onCloseChild: PropTypes.func,
    loadingEpisodeReviews: PropTypes.bool,
    isServer: PropTypes.bool,
    appEpisodeNumber: PropTypes.any,
    personalValues: PropTypes.object,
    rawTokenCount: PropTypes.object,
    personalMarkPlayedValues: PropTypes.object,
    setEpisodeAsPlayed: PropTypes.func,
    fetchAutoChapters: PropTypes.func,
    myFiles: PropTypes.object,
}

EpisodePage.defaultProps = {
    type: 'page'
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        userPlaylists: state.userPlaylists,
        personalValues: state.personalValues,
        personalMarkPlayedValues: state.personalMarkPlayedValues,
        myFiles: state.myFileEpisodes,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setEpisodeAsPlayed: bindActionCreators(setEpisodeAsPlayed, dispatch),
        fetchAutoChapters: bindActionCreators(fetchAutoChapters, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EpisodePage);
